import * as React from 'react';
import User from '../../domain/User';
import { connect } from 'react-redux';
import { default as DispatchProps, mapDispatchToProps } from '../../application/core/DispatchProps';
import './Client.css';
import addressBook from '../img/envelope.svg';
import home from '../img/homepage.svg';
import idCard from '../img/id-card.svg';
import Customer from '../../domain/Customer';
import { Link } from 'react-router-dom';
import RemoveCustomerRequested from '../../application/estimations/events/RemoveCustomerRequested';
import ResetPasswordRequested from '../../application/estimations/events/ResetPasswordRequested';

interface Props {
    client: Customer;
}

interface State {
    isEdited: boolean;
    editedData: Partial<User>;
}

class Client extends React.PureComponent<Props & DispatchProps, State> {
    constructor(props: Props & DispatchProps) {
        super(props);
        this.state = {
            isEdited: false,
            editedData: {}
        };
    }

    public render(): JSX.Element {
        const removeCustomer = (): void => {
            setTimeout(() => {
                this.props.dispatch(new RemoveCustomerRequested(this.props.client.customerId));
            }, 100);
        };
        const resetPassword = (): void => {
            setTimeout(() => {
                this.props.dispatch(new ResetPasswordRequested(this.props.client.customerId));
            }, 100);
        };
        return (
            <div key={this.props.client.customerId} className="client-container">
                <div className="client-data">
                    <div className="client-name">{this.props.client.name}</div>
                    <div className="client-contact">
                        <img className="client-icon" src={addressBook} />
                        {this.props.client.email}
                    </div>
                    <div className="client-contact">
                        <img className="client-icon" src={idCard} />
                        {this.props.client.customerId}
                    </div>
                    <div className="client-contact">
                        <img className="client-icon" src={home} />
                        <div className="client-contact-details">
                            <span>{this.props.client.name}</span>
                            {this.props.client.billingAddress !== undefined && (
                                <>
                                    <span>{this.props.client.billingAddress.address}</span>
                                    <span>
                                        {this.props.client.billingAddress.countryCode} {this.props.client.billingAddress.country}
                                    </span>
                                    <span>{this.props.client.billingAddress.state}</span>
                                    <span>{this.props.client.billingAddress.postCode}</span>
                                </>
                            )}
                        </div>
                    </div>
                    <div className="client-discount">
                        <div>
                            <span>Discount: {this.props.client.discountRate}%</span>
                            <span>Liability: {this.props.client.liabilityRate}%</span>
                        </div>
                    </div>
                    <div className="buttons">
                        <Link to={`/admin/customers/${this.props.client.customerId}`}>details</Link>
                        <div onClick={resetPassword}>reset password</div>
                        <div onClick={removeCustomer}>remove</div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    null,
    mapDispatchToProps
)(Client);



// WEBPACK FOOTER //
// ./src/view/admin/Client.tsx